import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { FAQS } from '../../lib/constants';

export const FAQ: React.FC = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    return (
        <section id="faq" className="py-32 bg-white">
            <div className="container mx-auto px-6 max-w-4xl">
                <div className="text-center mb-16">
                    <span className="text-[#11BC97] font-bold tracking-widest uppercase text-sm mb-4 block flex items-center justify-center gap-2">
                        <span className="w-8 h-[1px] bg-[#11BC97]"></span>
                        FAQ
                        <span className="w-8 h-[1px] bg-[#11BC97]"></span>
                    </span>
                    <h2 className="text-3xl md:text-5xl font-bold mb-4 text-black">Common Questions</h2>
                </div>

                <div className="space-y-4">
                    {FAQS.map((faq, idx) => (
                        <div key={idx} className={`rounded-[2rem] border transition-all duration-300 ${openIndex === idx ? 'bg-[#F8FDFB] border-[#11BC97]/30 shadow-lg shadow-[#11BC97]/5' : 'bg-white border-gray-100 hover:border-[#11BC97]/20'}`}>
                            <button
                                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                                className="w-full flex items-center justify-between p-8 text-left"
                            >
                                <span className={`font-bold text-lg pr-8 transition-colors ${openIndex === idx ? 'text-[#11BC97]' : 'text-black'}`}>{faq.question}</span>
                                <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${openIndex === idx ? 'bg-[#11BC97] text-white' : 'bg-gray-100 text-black group-hover:bg-[#11BC97]/10'}`}>
                                    {openIndex === idx ? (
                                        <Minus size={18} />
                                    ) : (
                                        <Plus size={18} />
                                    )}
                                </div>
                            </button>
                            <AnimatePresence>
                                {openIndex === idx && (
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <div className="p-8 pt-0 text-gray-600 leading-relaxed font-light">
                                            {faq.answer}
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};